/* Koppelt onze eigen "Schrijf een review"-knop aan het formulier van Judge.me.

   Judge.me laadt zijn widget pas na de pagina en rendert dan een eigen knop
   (.jm-action-buttons__button). Die knop opent het formulier. Wij klappen de
   uitklapper open, wachten tot die knop bestaat en klikken hem aan, zodat de
   bezoeker niet eerst zelf door de widget hoeft te zoeken. */
(function () {
  'use strict';

  var WIDGET = '#judgeme_product_reviews';
  var SCHRIJFKNOP = '.jm-action-buttons__button, .jdgm-write-rev-link';
  var FORMULIER = '.jm-review-form, .jdgm-form-wrapper, form';

  function zoekEnKlik(knop, poging) {
    var doel = document.querySelector(WIDGET + ' ' + SCHRIJFKNOP);

    if (doel) {
      doel.click();
      knop.removeAttribute('aria-busy');
      // Het formulier verschijnt pas na de klik, dus even wachten met scrollen.
      setTimeout(function () {
        var form = document.querySelector(WIDGET + ' ' + FORMULIER) || doel;
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var eerste = form.querySelector && form.querySelector('input, textarea, select');
        if (eerste) { eerste.focus({ preventScroll: true }); }
      }, 350);
      return;
    }

    // Judge.me heeft ongeveer tien seconden om te laden; daarna laten we de
    // uitklapper gewoon open staan zodat de bezoeker zelf verder kan.
    if (poging < 40) {
      setTimeout(function () { zoekEnKlik(knop, poging + 1); }, 250);
    } else {
      knop.removeAttribute('aria-busy');
      var w = document.querySelector(WIDGET);
      if (w) { w.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    }
  }

  document.addEventListener('click', function (e) {
    var knop = e.target.closest('[data-rev-schrijf]');
    if (!knop) { return; }
    e.preventDefault();

    var uitklap = document.querySelector('[data-rev-uitklap]');
    if (uitklap) { uitklap.open = true; }

    knop.setAttribute('aria-busy', 'true');
    zoekEnKlik(knop, 0);
  });
})();
